import { Label } from 'react-bootstrap'
import styled from 'styled-components';

const SctWrapper = styled.span`
    & > span.label {
        line-height: 1.5;
        padding: 2px 5px;
        width: 100%;
        display: ${p => p.displayAsInline ? 'inline-block' : 'inline'};
        font-size: 100%;
    }
`;

const AlleleMatch = (props: { bmtMm: number, displayAsInline: boolean, isPinnedRow?: boolean }) => {

    const { bmtMm, displayAsInline, isPinnedRow = false } = props;
    if (bmtMm == null) {
        return (
            <SctWrapper displayAsInline={displayAsInline}>
                <Label>{isPinnedRow ? '' : 'N/A'}</Label>
            </SctWrapper>
        );
    }

    return (
        <SctWrapper displayAsInline={displayAsInline}>
            <Label bsStyle={bmtMm >= 4 ? 'success' : 'default'}>{Math.abs(bmtMm)}/8</Label>
        </SctWrapper>
    );
}

export default AlleleMatch;
